export const dateToInitialMonth = (dateFrom, dateTo) => {
    if (dateTo){
        return new Date(dateTo);
    }
    else if (dateFrom) {
        return new Date(dateFrom);
    }
    else{
        return null;
    }
  };